import { WorkflowStep } from '../../workflow-navigation/reducers/workflow-step';
import { ScreenGuard } from './screen-index';
import { RaDeathAssessmentDetailsView } from '../../assessment/decisions';
import { WorkflowScreen } from '../../workflow-navigation/reducers/workflow-screen';
import { WorkflowAssessorScreen } from '../../workflow-navigation/reducers/workflow-assessor';
import { ClaimWorkflow } from './claim-workflow';
import { ClaimType } from '../../claim/claim-types';
import { RADeathSynopsis } from '../../assessment/synopsis/ra-death/ra-death-synopsis';
import { PaymentsView } from '../../payment';
import { WorkflowUtilityScreen } from '../../workflow-navigation/reducers/workflow-utility-screen';
import { ClaimAuditTrailView } from '../../claim-audit-trail';
import { DashboardFlowView } from '../../assesor-dashboard/views/dashboard/assessor-dashboard';
import { AuthGuard } from '../../auth/authGuard';

const screenGuardCapture = AuthGuard(['Agent', 'CentralPayments']);
const assessorDashboardGuard = AuthGuard(['AssessorDashboard']);

export const raDeathWorkflow = new ClaimWorkflow(
    'RA Death',
    [
        new WorkflowStep('Initiate Claim', []),
        new WorkflowStep('Assessment', [
            new WorkflowScreen('Synopsis', RADeathSynopsis, undefined, undefined, () => true),
            new WorkflowScreen(
                'Decisions',
                RaDeathAssessmentDetailsView,
                undefined,
                undefined,
                screenGuardCapture
            ),
        ]),
        new WorkflowStep('Payments', [
            new WorkflowScreen('Payments', PaymentsView, undefined, undefined, screenGuardCapture),
        ]),
        new WorkflowAssessorScreen(
            'Assessor List',
            'Assessor limits dashboard',
            DashboardFlowView,
            undefined,
            'Assessor limits dashboard',
            assessorDashboardGuard
        ),
        new WorkflowUtilityScreen(
            'Claim Audit Trail',
            'list',
            ClaimAuditTrailView,
            undefined,
            undefined,
            screenGuardCapture
        ),
    ],
    claim => claim.claimType === ClaimType.RADeath,
    undefined,
    ScreenGuard
);
